import Component from '../abstracts/Component';
import brightcovePlayerLoader from '@brightcove/player-loader';
import { trapFocusOnModal, removeTrapFocusOnModal } from '../utils/TrapFocus';

export default class PdpGalleryComponent extends Component {
  get SELECTORS() {
    return {
      thumbs: '[data-gallery-thumb]',
      slideVisible: '[data-gallery-main-img].on-view',
      slider: '[data-gallery-slider]',
      images: '[data-gallery-main-img]',
      gallery: '[data-gallery]',
      galleryCloseBtn: '[data-gallery-close]',
      prevArrow: '[data-prev-arrow]',
      nextArrow: '[data-next-arrow]',
      videoPdp: '[data-video-pdp]',
    };
  }

  get CLASSNAMES() {
    return {
      slideVisible: 'on-view',
      galleryShow: 'show',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.thumbs = this.$component.querySelectorAll(this.SELECTORS.thumbs);
    this.images = this.$component.querySelectorAll(this.SELECTORS.images);
    this.slider = this.$component.querySelector(this.SELECTORS.slider);
    this.currentSlide = this.$component.querySelector(this.SELECTORS.slideVisible);
    this.gallery = this.$component.querySelector(this.SELECTORS.gallery);
    this.closeBtn = this.$component.querySelector(this.SELECTORS.galleryCloseBtn);
    this.videosPdp = this.$component.querySelectorAll(this.SELECTORS.videoPdp);
  }

  isMobile() {
    let mq = window.matchMedia('(max-width:767px)');
    let isMobile = mq.matches;
    return isMobile;
  }

  thumbsHandler() {
    for (let thumb of this.thumbs) {
      thumb.addEventListener('click', () => {
        let targetId = thumb.dataset.targetImgId;
        this.currentSlide.classList.remove(this.CLASSNAMES.slideVisible);
        this.currentSlide = document.getElementById(targetId);
        this.currentSlide.classList.add(this.CLASSNAMES.slideVisible);
      });
    }
  }

  sliderHandler() {
    let mq = window.matchMedia('(max-width:767px)');
    this.mobileSlider(this.slider);
    mq.addListener(e => {
      if (e.matches) {
        this.mobileSlider(this.slider);
      } else {
        $(this.slider).slick('unslick');
      }
    });
  }

  mobileSlider(slider) {
    let prevLabel = slider?.dataset.prevLabel || '';
    let nextLabel = slider?.dataset.nextLabel || '';
    if (this.isMobile()) {
      $(slider).on('init', () => {
        this.animateArrows(slider);
      });
      this.moduleLoader.loadCarouselAndExecute(() => {
        $(slider).slick({
          dots: false,
          arrows: true,
          prevArrow:
            `<button type="button" class="w__slick-prev icon-slick-prev" aria-label="${prevLabel}" data-prev-arrow><i class="icon-slick-prev"></i></button>`,
          nextArrow:
            `<button type="button" class="w__slick-next icon-slick-next" aria-label="${nextLabel}" data-next-arrow><i class="icon-slick-next"></i></button>`,
          infinite: true,
          slidesToShow: 1,
          centerMode: false,
        });

        $(slider).on('afterChange', function(event, slick, currentSlide) {
          // Pause any video in all slides (to be safe)
          slick.$slides.each((i, slideEl) => {
            const vid = $(slideEl).find('video').get(0);
            if (vid && !vid.paused) {
              vid.pause();
            }
            // Also, if using Brightcove player API, call its pause method too.
          });

          // Now, find the video in the active slide
          const $activeSlide = $(slick.$slides[currentSlide]);
          const videoEl = $activeSlide.find('video').get(0);
          if (videoEl) {
            // Ensure it's muted (many browsers require muted autoplay)
            videoEl.muted = true;
            videoEl.play().catch(err => {
              console.warn("Video autoplay failed:", err);
            });
          }
        });

        $(slider).on('init', function(event, slick) {
          const $first = $(slick.$slides[0]);
          const vid0 = $first.find('video').get(0);
          if (vid0) {
            vid0.muted = true;
            vid0.play().catch(err => {
              console.warn("Initial video autoplay failed:", err);
            });
          }
        });
      });
    }
  }

  animateArrows(slider) {
    let prevArrow = slider.querySelector(this.SELECTORS.prevArrow);
    if (prevArrow) {
      prevArrow.addEventListener('mousedown', () => {
        prevArrow.classList.remove('transition');
      });
      prevArrow.addEventListener('click', () => {
        prevArrow.classList.add('transition');
      });
    }
    let nextArrow = slider.querySelector(this.SELECTORS.nextArrow);
    if (nextArrow) {
      nextArrow.addEventListener('mousedown', () => {
        nextArrow.classList.remove('transition');
      });
      nextArrow.addEventListener('click', () => {
        nextArrow.classList.add('transition');
      });
    }
  }

  galleryHandler() {
    let scrollY;
    if (this.images.length) {
      this.images.forEach(image => {
        if(image.dataset.galleryMainImg == 'image') {
          image.addEventListener('click', () => {
            let imgId = image.id;
            let targetImg = this.$component.querySelector(`[data-gallery-img="${imgId}"]`);
            this.gallery.classList.add(this.CLASSNAMES.galleryShow);
            targetImg.scrollIntoView();
            scrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
            this.trapFocusHandler = trapFocusOnModal(this.gallery);
            this.closeBtn.focus();
          });
          image.addEventListener('keydown', event => {
            if(event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              image.click();
            }
          });
        }
      });
    }
    this.closeBtn.addEventListener('click', () => {
      this.gallery.classList.remove(this.CLASSNAMES.galleryShow);
      document.body.style.position = '';
      window.scrollTo(0, scrollY);
      if (this.trapFocusHandler) {
        removeTrapFocusOnModal(this.gallery, this.trapFocusHandler);
        this.trapFocusHandler = null;
      }
    });
  }

  pdpVideoHandler() {
    if(this.videosPdp && this.videosPdp.length > 0){
      this.videosPdp.forEach(videoPdp => {
        brightcovePlayerLoader({
          refNode: videoPdp,
          refNodeInsert: 'prepend',
          accountId: videoPdp.dataset.accountId, //required - A Video Cloud account ID
          playerId: 'default', //required
          videoId: videoPdp.dataset.videoId,
          embedType: 'in-page', //in-page or iframe
          applicationId: "", // The application ID to be applied to the generated embed.
          embedOptions: {
            responsive: {
              aspectRatio: '3:4'
            }
          },
          options: {
            controls: false,
            loop: true,
            muted: true,
            poster: videoPdp.dataset.poster,
          },
        })
        .then(success => {
          const player = success.ref;
          const el = player.el();
          player.controlBar.hide();
          player.titleBar.hide();
          // prevent double click opening fullscreen
          el.addEventListener('dblclick', (e) => {
            e.stopPropagation();
            e.preventDefault();
          }, true);
          const playButton = videoPdp.querySelector("[data-video-play]");
          const pauseButton = videoPdp.querySelector("[data-video-pause]");
          playButton?.addEventListener("click", event => {
            event.preventDefault();
            player.play();
            playButton.classList.add("hidden");
            pauseButton.classList.remove("hidden");
            pauseButton.focus();
          });
          pauseButton?.addEventListener("click", event => {
            event.preventDefault();
            player.pause();
            playButton.classList.remove("hidden");
            pauseButton.classList.add("hidden");
            playButton.focus();
          });
          this.thumbs.forEach(thumb => {
            if(thumb.dataset.targetImgId === videoPdp.dataset.videoPdp) {
              thumb.addEventListener("click", () => {
                player.play();
                playButton.classList.add("hidden");
                pauseButton.classList.remove("hidden");
                pauseButton.focus();
              });
            }
          });
          player.on('pause', event => {
            playButton.classList.remove("hidden");
            pauseButton.classList.add("hidden");
            if (window.innerWidth >= 768) {
              playButton.focus();
            }
          });
          player.on('play', event => {
            playButton.classList.add("hidden");
            pauseButton.classList.remove("hidden");
            if (window.innerWidth >= 768) {
              pauseButton.focus();
            }
          });
        })
        .catch(error => {
          console.warn("Error creating video player.", error);
        });
      });
    }
  }

  render() {
    this.log('Rendering...');
    this.thumbsHandler();
    this.sliderHandler();
    this.galleryHandler();
    this.pdpVideoHandler();
  }
}
